import { ListGroupItem } from 'components/shared/ListGroup';
import type { IntlKey } from 'locales';
import { ReactNode } from 'react';

type DetailsItemProps = { label: IntlKey; e2e: string; children: ReactNode };
export function DetailsItem({ label, e2e, children }: DetailsItemProps) {
  return (
    <ListGroupItem className="ps-0 pe-3 text-nowrap" labelKey={label} data-e2e={e2e}>
      <span data-e2e={`${e2e}-value`} className="ms-3 text-truncate">
        {children}
      </span>
    </ListGroupItem>
  );
}
